
import { z } from "zod";

export const AuthStrategyValues = ["phone_code", "password", "reset_password_email_code", "ticket"] as const;
export const AuthStrategySchema = z.enum(AuthStrategyValues);
export const AuthStrategy = AuthStrategySchema.enum;
export type AuthStrategy = (typeof AuthStrategyValues)[number];
